import {
  GET_RESULT_CONTENT,
  UPDATE_VERIFICATION
} from './actionTypes';

export const getResultContent = ({ id, ddrType }) => ({
  type: GET_RESULT_CONTENT,
  id,
  ddrType
})

export const updateSweepSelectVerification = (id) => ({
  type: UPDATE_VERIFICATION,
  id
})